import { Chip } from '@workwave-tidal/core/components'
import React, { useMemo } from 'react'

type Props = {
  status: string
  isDefault?: boolean
}

export const KnockStatusChip: React.FC<Props> = ({
  status,
  isDefault = false,
}) => {
  const statusColor:
    | 'error'
    | 'success'
    | 'default'
    | 'primary'
    | 'secondary'
    | 'info'
    | 'warning'
    | undefined = useMemo(() => {
    if (isDefault) {
      return 'error'
    }

    return 'default'
  }, [isDefault])

  const statusStyle = useMemo(
    () =>
      isDefault
        ? {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: '#F7DAD5',
            color: '#2C4757',
            border: 'solid 1px #D63B1F',
          }
        : {
            '& .MuiChip-icon': { display: 'none' },
            backgroundColor: 'rgba(9, 27, 42, 0.08)',
            color: '#2C4757',
            border: 'solid 1px #091B2A8F',
          },
    [isDefault],
  )

  return (
    <Chip
      size="small"
      variant="filledOutline"
      label={status}
      color={statusColor}
      sx={{
        ...statusStyle,
        borderRadius: '4px',
        height: '24px',
        '& .MuiChip-label': {
          px: '8px',
          fontSize: '13px',
        },
      }}
    />
  )
}
